import { Card } from "../../card";
import { NumericValue } from "../../numeric-value";
import type { IProps } from "./metric-box.types";
import { FunctionComponent } from "react";

/**
 * Display a metric value optionally versus another overall value.
 * @param props.value          Value for the metric
 * @param props.icon           Icon for the metric.
 * @param props.isLoading      If the data is loading.
 * @param props.menuOptions    Menu actions for metrics
 * @param props.title          Label/description for the metric.
 * @param props.tooltipContent Explanation of the metric.
 * @param props.overallValue   Same metric value for all other agents.
 * @returns                    A metric icon, label, and values.
 */
const MetricBox: FunctionComponent<IProps> = ({
    comparisonValue,
    icon,
    isLoading,
    menuOptions,
    renderValue = (value, otherProps) => <NumericValue value={value} {...otherProps} />,
    title,
    tooltipContent,
    value,
    color,
    "data-testid": dataTestId,
    ...numericValueProps
}) => {
    return isLoading ? (
        <Card.Metric.Skeleton />
    ) : (
        <Card.Metric
            title={title}
            icon={icon}
            color={color}
            menu={menuOptions}
            metric={[
                {
                    value: typeof value === "number" ? renderValue(value, numericValueProps) : "--",
                    footer:
                        typeof comparisonValue === "undefined" || comparisonValue === null ? undefined : (
                            <span>
                                vs{" "}
                                {typeof comparisonValue === "number"
                                    ? renderValue(comparisonValue, numericValueProps)
                                    : "--"}{" "}
                                overall
                            </span>
                        ),
                },
            ]}
            data-testid={dataTestId}
        />
    );
};

export { MetricBox };
